<template>
<div
  v-show="isActive"
  :id="id"
  :class="$c('tab')"
  role="tabpanel"
  :aria-hidden="!isActive"
>
  <slot v-if="isInited || isActive">
    <router-view v-if="to && $route && isMatched"/>
  </slot>
</div>
</template>

<script>
import 'veui/locale/zh-Hans/common.js'
import 'veui/locale/en-US/common.js'

import { pick, find, uniqueId, includes } from 'lodash'
import { getTypedAncestorTracker } from '../../utils/helper'
import { getIndexOfType } from '../../utils/context'
import warn from '../../utils/warn'
import '../../common/uiTypes'
import prefix from '../../mixins/prefix'

const STATUS_LIST = ['success', 'warning', 'info', 'error']

export default {
  name: 'veui-tab',
  uiTypes: ['tab'],
  mixins: [prefix, getTypedAncestorTracker('tabs')],
  props: {
    label: {
      type: String,
      required: true
    },
    name: String,
    disabled: {
      type: Boolean,
      default: false
    },
    to: {
      type: [String, Object],
      default: ''
    },
    matches: Function,
    native: Boolean,
    removable: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: null,
      validator (val) {
        return includes(STATUS_LIST, val)
      }
    }
  },
  data () {
    return {
      id: uniqueId('veui-tab-'),
      isInited: false
    }
  },
  computed: {
    isActive () {
      return this.id === this.tabs.activeId
    },
    realTo () {
      if (!this.to) {
        return null
      }

      return this.$router && typeof this.to === 'string'
        ? this.$router.resolve(this.to).route
        : this.to
    },
    realMatches () {
      return this.matches || this.tabs.matches || (() => false)
    },
    isMatched () {
      return this.realMatches(this.$route, this.realTo)
    }
  },
  created () {
    let index = getIndexOfType(this, 'tabs')

    const props = ['label', 'disabled', 'to', 'native', 'removable', 'status']

    if (this.to && this.name) {
      warn(
        '[veui-tab] prop `name` will be ignored when prop `to` is set.',
        this
      )
    }

    this.tabs.add(
      {
        ...pick(this, ...props, 'id'),
        name: this.realTo ? this.realTo.fullPath : this.name || this.id,
        index
      },
      this.to && this.isMatched
    )

    props.forEach(prop => {
      this.$watch(prop, val => {
        find(this.tabs.items, item => item.id === this.id)[prop] = val
      })
    })

    if (!this.isActive) {
      let unWatchIsActive = this.$watch('isActive', () => {
        this.isInited = true
        unWatchIsActive()
      })
    } else {
      this.isInited = true
    }
  },
  destroyed () {
    this.tabs.removeById(this.id)
  }
}
</script>
